import { createFileRoute } from "@tanstack/react-router";
import UnderstandingPhq9Gad7 from "@/pages/articles/UnderstandingPhq9Gad7";
export const Route = createFileRoute(
  "/understanding-your-phq-9-and-gad-7-scores",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "Understanding Your Phq 9 And Gad 7 Scores | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Understanding your PHQ-9 and GAD-7 scores. Learn what the numbers mean for depression and anxiety treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content:
            "Understanding Your Phq 9 And Gad 7 Scores | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Understanding your PHQ-9 and GAD-7 scores. Learn what the numbers mean for depression and anxiety treatment in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/understanding-your-phq-9-and-gad-7-scores",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/understanding-your-phq-9-and-gad-7-scores",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <UnderstandingPhq9Gad7 />;
}
